<template>
  <div class="btn-orange">
    <router-link to="/monitoramento">
      <mdicon name="WebBox" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-2xl text-center font-semibold mb-4">{{ title }}</h2>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
}
</script>
